// Empty — all products come from the Laravel API.
// This file is kept as a module boundary for compatibility.
export const INITIAL_PRODUCTS = [];
